import AuthorizationService from "../../services/AuthorizationService";
import HttpService, {
  HttpMethod,
  ISearchParams,
} from "../../services/HttpService";
import AppPropsService from "../../services/AppPropsService";
import { IFetchLogsRequestBody } from "../../content/MainContent/AccountInfoPage/AccountLogs/LogsPage.container";

const generateUrl = (resourcePath: string, searchParams?: ISearchParams) => {
  const API_URL_PATH = AppPropsService.getVoiceGainApplicationApiUrlPath();
  const SERVER_URL = AppPropsService.getVoiceGainServerUrl();
  return HttpService.generateUrl(
    API_URL_PATH,
    resourcePath,
    SERVER_URL,
    searchParams
  );
};

abstract class VoiceGainApplicationApi {
  public static getContexts = (): Promise<Response> => {
    const method = HttpMethod.Get;
    const url = generateUrl(`/confgroup`);
    const requestInfo: RequestInfo = url.toString();
    const requestInit: RequestInit = { method };
    return AuthorizationService.authorizedFetch(requestInfo, requestInit);
  };

  public static getEdgeDeployments = (): Promise<Response> => {
    const method = HttpMethod.Get;
    const url = generateUrl(`/cluster`);
    const requestInfo: RequestInfo = url.toString();
    const requestInit: RequestInit = { method };
    return AuthorizationService.authorizedFetch(requestInfo, requestInit);
  };

  public static getAccountLogs = (
    fetchLogsRequestBody: IFetchLogsRequestBody,
    accountId: string
  ): Promise<Response> => {
    const method = HttpMethod.Post;
    const body = JSON.stringify({ ...fetchLogsRequestBody, accountId });
    const headers = { "Content-Type": "application/json" };
    const url = generateUrl(`/log`);
    const requestInfo: RequestInfo = url.toString();
    const requestInit: RequestInit = { method, body, headers };
    return AuthorizationService.authorizedFetch(requestInfo, requestInit);
  };

  public static fetchApiRequestsCount = (): Promise<Response> => {
    const method = HttpMethod.Get;
    const url = generateUrl(`/log/time-series/data`);
    url.searchParams.append("q", "getApiRequestCounts");
    url.searchParams.append("timePeriod", "42d");
    url.searchParams.append("timeSplit", "1d");
    url.searchParams.append("perAccount", "true");
    url.searchParams.append("useMasterDb", "true");
    const requestInfo: RequestInfo = url.toString();
    const requestInit: RequestInit = { method };
    return AuthorizationService.authorizedFetch(requestInfo, requestInit);
  };
}

export default VoiceGainApplicationApi;
